import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-blush-50 py-16 sm:py-20" aria-labelledby="bonuses-heading" data-id="element-13" data-mp="av36mvbir927">
      <div className="mx-auto max-w-6xl px-5" data-id="element-14" data-mp="at8w8axvizcd">
        <div id="bonuses-heading" data-id="element-15" data-mp="ftejlex41zon">
          <SectionHeading eyebrow="🎁 Special bonuses included" title="Get These 3 Bonuses FREE With Your Order Today" subtitle="When you grab My Enchanted Paper World today, you'll also receive these 3 special bonus collections — included at no additional charge and yours to keep." data-id="element-16" data-mp="fsbsp6zsfx8q" />
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-17" data-mp="3t06e2moyjx5s">
          {bonuses.map((bonus, index) => <motion.article key={bonus.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          delay: index * 0.1
        }} className="flex flex-col overflow-hidden rounded-4xl bg-white shadow-card" data-id="element-18" data-mp="1m9qen74mz1g0" data-mpi={index}>
              <div className="relative" data-id="element-19" data-mp="3r6qhck1lsahk">
                <img src={bonus.image} alt={bonus.title} className="h-52 w-full object-cover" loading="lazy" data-id="element-20" data-mp="3r5gi3rj0kw9c" />
                <span className="absolute right-3 top-3 rounded-full bg-sun-300 px-3 py-1 text-xs font-bold text-ink" data-id="element-21" data-mp="2zgddgan7tjw6">
                  {bonus.value}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-22" data-mp="38hbi8v5h9vft">
                <p className="font-display text-xs font-bold uppercase tracking-wide text-blush-500" data-id="element-23" data-mp="33h5n35001qsz">
                  {bonus.label}
                </p>
                <h3 className="mt-1.5 font-display text-xl font-bold text-ink" data-id="element-24" data-mp="noqax9bp4d62">{bonus.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-25" data-mp="iq576zx8jbcv">{bonus.text}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}